<template>
  <div class="fee-template main-container">
      <div class="top-box">
          <div class="title-text">{{ query.productName }}</div>
          <Button type="primary" @click="close">返回</Button>
      </div>

      <loading :isShow="loading" />
      <Table :columns="columns" :data="tableData"> </Table>
  </div>
</template>

<script>
import filter from '@/api/filter';
export default {
  data() {
      return {
          filter,
          loading: false,
          query: {},
          tableData: [], //表格数据
          columns: [
              {
                  title: '变更时间',
                  align: 'center',
                  minWidth: 150,
                  render(h, params) {
                      return <span>{filter.filterTime(params.row.updateTime, 'YYYY/MM/DD HH:mm')}</span>;
                  }
              },
              {
                  title: '变更人',
                  key: 'changeName',
                  align: 'center',
                  minWidth: 80
              },
              {
                  title: '险种名称',
                  key: 'productName',
                  align: 'center',
                  minWidth: 250
              },
              {
                  title: '方案名称',
                  key: 'programName',
                  align: 'center',
                  minWidth: 100,
                  tooltip: true
              },
              {
                  title: '期数',
                  align: 'center',
                  minWidth: 100,
                  render(h, params) {
                      let commissionIndex = params.row.commissionIndex;
                      return <span>第{filter.numberTransform(commissionIndex)}年</span>;
                  }
              },
              {
                  title: '保障期',
                  key: 'guaranteeContent',
                  align: 'center',
                  minWidth: 150,
                  render(h, params) {
                      let guaranteeContent = params.row.guaranteeContent;
                      return <span>{guaranteeContent ? guaranteeContent : '-'}</span>;
                  }
              },
              {
                  title: '缴费期',
                  key: 'payContent',
                  align: 'center',
                  minWidth: 150
              },
              {
                  title: '区域',
                  key: 'regionContent',
                  align: 'center',
                  minWidth: 200,
                  tooltip: true
              },
              {
                  title: '是否含身故',
                  key: '',
                  align: 'center',
                  minWidth: 100,
                  render(h, params) {
                      let includingDeath = params.row.includingDeath;
                      return <span>{includingDeath == 1 ? '是' : '否'}</span>;
                  }
              },
              {
                  title: '变更费用',
                  align: 'center',
                  minWidth: 150,
                  render(h, params) {
                      let oldValue = params.row.oldValue * 100 + '%';
                      let newValue = params.row.newValue * 100 + '%';
                      return (
                          <span>
                              {oldValue} —> {newValue}
                          </span>
                      );
                  }
              },
              {
                  title: '类型',
                  align: 'center',
                  minWidth: 80,
                  render(h, params) {
                      let commissionType = params.row.commissionType;
                      if (commissionType == 1 || commissionType == 3) {
                          return <span>服务费</span>;
                      } else if (commissionType == 2) {
                          return <span>管理费</span>;
                      } else {
                          return <span>-</span>;
                      }
                  }
              }
          ]
      };
  },

  mounted() {
      this.query = this.$route.query;
      this.getData();
  },

  methods: {
      // 获取费率数据
      getData() {
          this.loading = true;
          this.$http({
              url: '/buz/commissionChangeRecord/read/list',
              type: 'POST',
              data: {
                  organizationId: this.query.id,
                  organizationType: this.query.nodeType,
                  productCode: this.query.productCode
              }
          })
              .then(res => {
                  this.tableData = res.data;
                  console.log(res.data);
              })
              .finally(() => {
                  this.loading = false;
              });
      },

      // 关闭当前页面
      close() {
          const fullPath = this.$route.fullPath;
          window.parent.postMessage(
              {
                  removePageTag: fullPath,
                  appMessage: true
              },
              '*'
          );
      }
  }
};
</script>
<style lang="scss">
.fee-template {
  $tdWidth: 100px;
  background-color: #fff;

  .top-box {
      position: relative;
      margin-bottom: 20px;

      .title-text {
          font-size: 20px;
          color: #3c464f;
          font-weight: bold;
      }

      .ivu-btn {
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
      }
  }
}
</style>
